import React from "react";
import IncomeCard from "../../components/IncomeCard/IncomeCard";

export default function GlobalIncome({ incomeStats, pendingRoyalty, onRefresh }) {
  return (
    <div className="plan-income-list">
      <IncomeCard label="Direct Referral" totalEarned={incomeStats?.direct} color="#00ff88" />
      <IncomeCard label="Level Income" totalEarned={incomeStats?.level} color="#00f0ff" />
      <IncomeCard label="Global Share" totalEarned={incomeStats?.div} color="#8b5cf6" />
      <IncomeCard label="Royalty Income" totalEarned={incomeStats?.royalty} pendingAmount={pendingRoyalty} color="#f0a030" />
      <button className="ht-refresh" onClick={onRefresh}>Refresh</button>
    </div>
  );
}
